import { Dispatch, ReactNode, SetStateAction, createContext } from 'react';
import { useDataInitializer } from '../containers/app/app.hooks';
import { useGlobalMessage } from '../containers/global-message/global-message.hooks';
import type { GlobalMessage } from '../containers/global-message/global-message.type';
import { useVersionCheck } from '../hooks/useVersionCheck';

type GlobalContextType = {
  globalMessage: GlobalMessage | null;
  setGlobalMessage: Dispatch<SetStateAction<GlobalMessage | null>>;
};

export const GlobalContext = createContext({} as GlobalContextType);

export function GlobalProvider({ children }: { children: ReactNode }) {
  useDataInitializer();
  useVersionCheck();
  const { globalMessage, setGlobalMessage } = useGlobalMessage();

  return <GlobalContext.Provider value={{ globalMessage, setGlobalMessage }}>{children}</GlobalContext.Provider>;
}
